import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import Validator from 'validatorjs';
import validatorEnMessages from 'validatorjs/src/lang/en';
import './index.css';
import App from './imports/App';
import { Auth0Provider } from './imports/react-auth0-spa';
import history from './imports/utils/history';

// Register English messages explicitly — validatorjs's dynamic require()
// for language files doesn't work in Vite's ESM bundle.
Validator.setMessages('en', validatorEnMessages);

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_CI_COMMIT_SHORT_SHA,
    environment: import.meta.env.MODE,
  });
}

const onRedirectCallback = appState => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

const root = createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={import.meta.env.VITE_AUTH0_DOMAIN}
    client_id={import.meta.env.VITE_AUTH0_CLIENT_ID}
    audience={import.meta.env.VITE_AUTH0_AUDIENCE}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
    scope="preferred_username"
    useRefreshTokens
    cacheLocation="localstorage"
  >
    <App />
  </Auth0Provider>
);
